<template>
  <Modal
    v-model="innerShow"
    :title="title"
    :width="width"
    :mask-closable="false"
    :closable='true'
    @on-ok="confirm"
    @on-cancel="close"
    @on-visible-change="show"
    class="vertical-center-modal yjh-diag">
      <div v-if="!html" class="simple-diag-text">{{content}}</div>
      <slot></slot>
      <template slot="footer">
        <Button v-if="!onlyOK" @click="close" :disabled="disabled" style="width: 68px;">{{cancelText}}</Button>
        <Button @click="confirm" type="primary" :disabled="disabled" style="width: 68px;">{{okText}}</Button>
      </template>
    </Modal>
</template>

<script>
export default {
  props: {
    isShow: Boolean,
    title: {
      type: String,
      default: '提示'
    },
    width: {
      type: String,
      default: '500px'
    },
    content: String,
    html: {
      type: Boolean,
      default: false
    },
    onlyOK: {
      type: Boolean,
      default: false
    },
    okText: { // 19-07-23 确定按钮text
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerShow: false
    }
  },
  watch: {
    isShow() {
      this.innerShow = this.isShow
    }
  },
  mounted() {
    this.innerShow = this.isShow
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    },
    show(flag) {
      if (flag) {
        this.$emit('show')
      } else {
        this.$emit('hide')
      }
    }
  }
}
</script>
<style lang="scss" scoped="">
</style>
